<template>
    <div class="verify__wrap">
        <template v-if="pageLoading">
            <PageSpinner />
        </template>
        <template v-else-if="pageErr">
            <EmptyPage 
                state="error_custom" 
                title="Charge failed" 
                btn-state="custom"
                class="verify__wrap__empty"
                subtitle="Unable to verify attempt to charge your card. Please, try again."
                @action="goBack"
            >
                <template #button>
                    <BaseButton 
                        label="Back to dashboard" 
                        icon-name="chevron-left" 
                        prefix-icon 
                        @submit="goBack"
                    />
                </template>
            </EmptyPage>
        </template>
    </div>
</template>

<script>
import { PageSpinner, EmptyPage, BaseButton } from "@/components/ui/index";

export default {
    name: "VerifyBillingPage",

    components: {
        PageSpinner,
        EmptyPage,
        BaseButton,
    },

    data() {
        return {
            pageLoading: true,
            pageErr: false,
        };
    },

    async mounted() {
        const params = new URLSearchParams(window.location.search);
        const reference = params.get("trxref");

        await this.verifyTransactionCharge(reference);
    },

    methods: {
        async verifyTransactionCharge(ref) {
            try {
                this.pageErr = false;
                this.pageLoading = true;

                if (!ref) {
                    this.pageErr = true;
                    this.$toast.error("Invalid transaction reference.");
                    return;
                }

                const targetPlan = sessionStorage.getItem("z:t_p");
                const encryptedType = sessionStorage.getItem("z:t_type");
                const defaultCard = sessionStorage.getItem("z:t_d");

                if (!targetPlan || !encryptedType) {
                    throw new Error("Unable to process your request. Please try again.");
                }

                const res = await this.$store.dispatch("subscription/verifyCharge", { 
                    targetPlan: targetPlan, 
                    reference: ref, encryptedType, 
                    setCardDefault: defaultCard, 
                });

                console.log({ verifyTransactionCharge: res });

                if (!res || !res.isSuccessful) {
                    this.pageErr = true;
                    this.$toast.error("Unable to verify transaction");
                    return;
                }

                this.$toast.success(res.message);

                const page = localStorage.getItem("z_sub_page");

                if (!page || page !== "hdguod") {
                    return this.$router.push("/dashboard/settings/payments-and-billings");
                } else {
                    return this.$router.push({ name: "reports", query: { type: "clients", range: "1_year" } });
                }
            } catch (error) {
                this.pageErr = true;
                
                const errMsg = error?.response?.data?.message || error.message;                
                this.$toast.error(errMsg);
            } finally {
                this.pageLoading = false;
            }
        },

        goBack() {
            this.$router.push("/dashboard/settings/payments-and-billings");
        },
    },
};
</script>

<style lang="scss" scoped>
.verify__wrap {
    height: 100vh;

    &__empty {
        margin: 6rem auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
    }
}
</style>